import Component from '@glimmer/component';
import { pageTitle } from 'ember-page-title';
import Modal from 'bcl/components/modal';
import SupplierEdit from 'bcl/components/supplier-edit';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type SupplierModel from 'bcl/models/supplier';

export interface BDSupplierSignature {
  // The arguments accepted by the component
  Args: {
    model: SupplierModel;
  };
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: null;
}

export default class BDSupplierComponent extends Component<BDSupplierSignature> {
  @service declare router: RouterService;
  closeModal = () => {
    this.router.transitionTo('auth.basic-data');
  };

  <template>
    {{pageTitle "Lieferant bearbeiten | Barvera" replace=true}}
    <Modal @size="big">
      <SupplierEdit @model={{@model}} @closeModal={{this.closeModal}} />
    </Modal>
  </template>
}
